import { render, staticRenderFns } from "./ManageVersionsDialog.vue?vue&type=template&id=c6c15582&scoped=true"
import script from "./ManageVersionsDialog.vue?vue&type=script&lang=js"
export * from "./ManageVersionsDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageVersionsDialog.vue?vue&type=style&index=0&id=c6c15582&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c15582",
  null
  
)

export default component.exports